import { SendBackProvider } from './SendBackPageContext';
import SendBackScreenContainer from '../../containers/SendBackScreenContainer';

export default function SendBackPage() {
  return (
    <SendBackProvider>
      <SendBackScreenContainer />
    </SendBackProvider>
  );
}
